import { ModuleSelectorItem } from "../module-selector-item/ModuleSelectorItem";
import { Stack } from "@mui/material";
import { ModuleType } from "../../types/ModuleType";
import { useAppContext } from "../../../../shared/contexts/app-context/components/AppContext";

export function ModuleSelector() {
    const { marketDataDto } = useAppContext();

    return (
        <Stack
            direction="row"
            sx={{
                background: '#22293A',
                color: 'white',
            }}
        >
            <ModuleSelectorItem type={ModuleType.OptionsTable} caption="OPTIONS TABLE"/>
            <ModuleSelectorItem type={ModuleType.PositionsAndOrders} caption="POSITIONS & ORDERS"/>
            <ModuleSelectorItem type={ModuleType.BalanceProfile} caption="BALANCE PROFILE"/>
            <ModuleSelectorItem type={ModuleType.ParametersProfile} caption="PARAMETERS PROFILE"/>
            {
                marketDataDto?.ApplicationState.ApplicationSettings.FeatureFlags.EnablePortfolioBalancerTab &&
                    <ModuleSelectorItem type={ModuleType.PortfolioBalancer} caption="PORTFOLIO BALANCER"/>
            }
            {
                marketDataDto?.ApplicationState.ApplicationSettings.FeatureFlags.EnableBalanceHistoryTab &&
                    <ModuleSelectorItem type={ModuleType.BalanceHistory} caption="BALANCE HISTORY"/>
            }
            {
                marketDataDto?.ApplicationState.ApplicationSettings.FeatureFlags.EnableBinanceTab &&
                    <ModuleSelectorItem type={ModuleType.Binance} caption="BINANCE"/>
            }
        </Stack>
    );
}
